import { io } from "socket.io-client";
import { api, API_ORIGIN } from "./api";

let _socket = null;

export function getSocket() {
  return _socket;
}

export async function connectSocket() {
  if (_socket && _socket.connected) return _socket;
  // Fetch a fresh short-lived token
  let token;
  try {
    const { data } = await api.get("/auth/socket-token");
    token = data.token;
  } catch {
    return null;
  }
  _socket = io(API_ORIGIN, {
    path: "/api/socket.io",
    transports: ["websocket", "polling"],
    auth: { token },
    reconnection: true,
    reconnectionDelay: 1500,
  });
  return _socket;
}

export function disconnectSocket() {
  if (_socket) {
    _socket.disconnect();
    _socket = null;
  }
}
